import React from 'react'
import { useHistory } from 'react-router-dom'
import headerImg from '../assets/heroimage.gif'
import Button from './Button'

const Header = () => {
    const history = useHistory()

    //handle click
    const handleClick = () => {
        history.push('/services')
    }
    return (
        <header className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 z-50">
            <div className="flex flex-col justify-center space-y-6">
                <h1 className="text-3xl font-semibold text-gray-500 font_poppins leading-12" style={{lineHeight:'45px'}}>
                Do you want to <br />
                learn any <br />
                    <span className="text-5xl text-indigo-700">languages ?</span>
                </h1>
                <Button text="Start Learning" onClick={handleClick} />
            </div>
            <div>
                <img src={headerImg} alt="header" />
            </div>
        </header>
    )
}

export default Header
